import React, { useState, useEffect, useContext} from 'react';
import { AuthContext } from '../../../shared/context/auth-context';

import { MdDeleteOutline } from "react-icons/md";
import './userHandler.css';



const UserHandler = () => {

  const auth = useContext(AuthContext);

  const [user, setUser] = useState([])
  const [loaded, setIsLoaded] = useState(false);

  // Fetching all users
  useEffect(() => { 
    const fetchUsers = async () => {
      setIsLoaded(true)
      try {
        const response = await fetch(process.env.REACT_APP_BACKEND_URL + '/users'); // backUrl
        const responseData = await response.json();
        setUser(responseData.users)
        setIsLoaded(true);

      } catch (err) {
        console.log(err)
      }
      
    };
    fetchUsers();
    setIsLoaded(false)
  }, [])



//  Delete news
  const handleDeleteUser = async (userId) => {
    // const token = localStorage.getItem('token');

    const confirm = window.confirm('Are sure you want to delete this user!')

    if(!confirm){
        return;
    }

    try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/users/${userId}`,{
            method: 'DELETE',
            headers: {
              'Authorization': 'Bearer ' + auth.token
            }
        });

        if (!response.ok){
            throw new Error('Could not delete user for provided id.')
        };

        setUser(prevUser => prevUser.filter(u => u.id !== userId));
        console.log('deleted')

    } catch (err) {
        console.log(err.message)
    }

  }



    return (
       
        <main className='userHandler-lists-container'>
              <table className='userHandler-table-controller'>   
                <thead>
                <tr className='table-tr'>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th>Posts</th>
                    <th id='table-edit'>Edit/Delete</th>
                </tr>    
                </thead>
                <tbody className='userHandler-tbody'>
                {loaded && user.map((u,index) => (
                  <tr key={index} className='userHandler-lists-tr' > 
                   
                    <td>{u.name}</td>
                    <td>{u.email}</td>
                    <td>{u.role}</td>
                    <td>{u.posts.length}</td>
                                   
                    <td id='table-delete'>
                
                      <MdDeleteOutline onClick={() => handleDeleteUser(u.id)} style={{fontSize: '25px', color: 'red', marginRight: '15px'}}/>
                    </td>
              
                  </tr>
                ))}
             </tbody>
              </table>
            </main>

    )
}

export default UserHandler;